import { DataImportActions2 } from './../../../generic/models/data-import-2-config';
import { PrintTriggerDialogComponent } from 'src/app/shared/print-trigger-dialog/print-trigger-dialog.component';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '@optsolservices/ngx-notification';
import { BaseService } from 'src/app/core/services/base.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

export interface SendEmailDialogData {

}

@Component({
  selector: 'app-sct-confirm-dialog',
  templateUrl: './sct-confirm-dialog.component.html',
  styleUrls: ['./sct-confirm-dialog.component.scss']
})
export class SctConfirmDialogComponent implements OnInit {
  cancelForm: FormGroup;

  cancelReasonCodes: {
    reasonCode: string;
    description: string;
  }[];

  mode: string; // INTEGRATE-SCT | INTEGRATE-GTR | GENERATE-GIT-DEL-NOTE | CANCEL-SCT-HEADER | CANCEL-SCT-HEADER-INT

  title: string;
  confirmMessage: string;
  acceptActionButtonText: string;
  declineActionButtonText: string;

  constructor(
    public dialogRef: MatDialogRef<SctConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private baseService: BaseService,
    private fb: FormBuilder,
  ) {
    this.cancelForm = fb.group({
      cancelReasonCode: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.mode = this.data.additionalData?.actionCode;

    // Integrate SCT
    if (this.mode === 'INTEGRATE-SCT') {
      this.title = 'Confirm SCT Creation';
      this.confirmMessage = 'Are you sure you wish to create this SCT in Syspro?';
      this.acceptActionButtonText = 'Create in Syspro';
      this.declineActionButtonText = 'Cancel';
    }

    // Integrate GIT
    else if (this.mode === 'INTEGRATE-GTR') {
      this.title = 'Confirm GIT Creation';
      this.confirmMessage = 'Are you sure you wish to create this GIT in Syspro?';
      this.acceptActionButtonText = 'Create in Syspro';
      this.declineActionButtonText = 'Cancel';
    }

    // Generate GIT Delivery Note
    else if (this.mode === 'GENERATE-GIT-DEL-NOTE') {
      this.title = 'Confirm Generate GIT Delivery Note';
      this.confirmMessage = 'Are you sure you wish to generate the GIT delivery note?';
      this.acceptActionButtonText = 'Generate and Download';
      this.declineActionButtonText = 'Cancel';
    }

    // Cancel SCT Header (in our world)
    else if (this.mode === 'CANCEL-SCT-HEADER') {
      this.title = 'Confirm Cancel SCT';
      this.confirmMessage = 'Are you sure you wish to cancel this SCT?';
      this.acceptActionButtonText = 'Cancel SCT';
      this.declineActionButtonText = 'Close';

      this.baseService.executeCommand<any>('portal_sct_header_cancel_dialog_config', { sctHeaderId: this.data?.data?.sctHeaderId })
        .subscribe(response => {
          if (response.responseCode === 0) {
            this.cancelReasonCodes = response.data?.reasons || [];
          }
        });
    }

    // Cancel SCT Header in Syspro
    else if (this.mode === 'CANCEL-SCT-HEADER-INT') {
      this.title = 'Confirm Cancel SCT in Syspro';
      this.confirmMessage = 'Are you sure you wish to cancel this SCT in Syspro?';
      this.acceptActionButtonText = 'Cancel SCT';
      this.declineActionButtonText = 'Close';

      this.baseService.executeCommand<any>('portal_sct_header_cancel_dialog_config', { sctHeaderId: this.data?.data?.sctHeaderId })
        .subscribe(response => {
          if (response.responseCode === 0) {
            this.cancelReasonCodes = response.data?.reasons || [];
          }
        });
    }
  }

  action() {
    if (this.mode === 'INTEGRATE-SCT') {
      const dialogData: OiGroupDialogData = {
        title: 'Creating SCT in Syspro',
        function: 'portal_oi_group_sct_header_create_sct',
        postBody: {
          sctHeaderId: this.data.sctHeaderId,
        }
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0) {
          this.notificationService.success('SCT Created in Syspro');
          this.dialogRef.close(true);
        }
      });
    } else if (this.mode === 'INTEGRATE-GTR') {
      const dialogData: OiGroupDialogData = {
        title: 'Creating GIT in Syspro',
        function: 'portal_oi_group_sct_header_create_gtr',
        postBody: {
          salesOrderNumber: this.data.salesOrder,
        }
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0) {
          this.notificationService.success('GIT Created in Syspro');
          this.generateDeliveryNote(this.data.data);
        }
      });
    } else if (this.mode === 'GENERATE-GIT-DEL-NOTE') {
      this.generateDeliveryNote(this.data.data);
    } else if (this.mode === 'CANCEL-SCT-HEADER') {
      this.baseService.executeCommand<any>('portal_sct_header_cancel', { sctHeaderId: this.data?.data?.sctHeaderId, ...this.cancelForm.getRawValue() })
        .subscribe(response => {
          if (response.responseCode === 0) {
            this.dialogRef.close(true);
          }
        });


    } else if (this.mode === 'CANCEL-SCT-HEADER-INT') {
      const dialogData: OiGroupDialogData = {
        title: 'Cancelling SCT in Syspro',
        function: 'portal_oi_group_sct_header_cancel_sct',
        postBody: {
          salesOrderNumber: this.data.salesOrder,
          ...this.cancelForm.getRawValue()
        }
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0) {
          this.notificationService.success('SCT Cancelled in Syspro');
          this.dialogRef.close(true);
        }
      });
    }

  }

  generateDeliveryNote(data: any) {
    const ref = this.dialog.open(PrintTriggerDialogComponent, {
      data: {
        title: 'Generating Delivery Note Document',
        function: 'portal_syspro_order_create_print_trigger',
        postBody: Object.assign(data, { documentType: 'GTR-DELIVERY-NOTE' })
      },
      width: '600px'
    });

    ref.afterClosed().subscribe(
      response => {
        this.baseService.executeCommand<any>('portal_sct_header_delivery_note_download_config', {...this.data.data, printTriggerId: response })
          .subscribe(response => {
            if (response.responseCode === 0) {
              this.notificationService.success('Downloading delivery note');
              this.baseService.downloadResource(response.data.apiResourceKey, response.data.fileName, response.data.mimeType);
              this.dialogRef.close(true);
            } else {
              this.dialogRef.close(true);
            }
          })
      },
      error => {
        this.dialogRef.close(true);
      });
  }

}
